export const getCurrentProductId = state => state.rootReducer.buyCourse.currentProductId;
export const getCouponCode = state => state.rootReducer.buyCourse.couponCode; 
export const getState = state => state.rootReducer.buyCourse; 
export const getOrderId = state => state.rootReducer.buyCourse.orderId; 